import { Link } from 'react-router-dom';
import { articles, hotArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

const formatViews = (views: number): string =>
  views >= 10000 ? `${(views / 10000).toFixed(1)} 万` : `${views}`;

export default function HotBoard() {
  const latest = [...articles]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 5);

  return (
    <section className="bg-background-100/70 border-b border-background-200" id="hot">
      <div className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 font-label">HOT BOARD</p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              本周热搜反差榜
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-xl">
              按阅读量与讨论热度排序，选取本周被反复回看的现场素材。
            </p>
          </div>
          <Link
            to="/category/candid"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-label whitespace-nowrap"
          >
            查看全部档案
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-7">
            <ol className="space-y-1">
              {hotArticles.map((article, index) => (
                <li key={article.id}>
                  <Link
                    to={`/article/${article.slug}`}
                    className="group flex items-start gap-4 md:gap-5 p-4 rounded-lg hover:bg-background-50 transition-colors"
                  >
                    <span
                      className={`w-8 md:w-9 shrink-0 font-heading text-2xl md:text-3xl font-black leading-none ${
                        index === 0
                          ? 'text-primary-500'
                          : index === 1
                            ? 'text-accent-600'
                            : 'text-foreground-300'
                      }`}
                    >
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2 text-xs font-label mb-1.5">
                        <span className="text-secondary-700">{article.categoryName}</span>
                        {article.rank <= 3 && (
                          <span className="text-primary-600 flex items-center gap-1">
                            <i className="ri-fire-line" aria-hidden="true" />
                            热
                          </span>
                        )}
                      </span>
                      <span className="block font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
                        {article.title}
                      </span>
                      <span className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500 font-label">
                        <span>{article.date}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line" aria-hidden="true" />
                          {formatViews(article.views)}
                        </span>
                      </span>
                    </span>
                    <i
                      className="ri-arrow-right-up-line text-lg text-foreground-300 group-hover:text-primary-500 transition-colors mt-1 shrink-0"
                      aria-hidden="true"
                    />
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 mb-5">
                <i className="ri-history-line text-primary-500" aria-hidden="true" />
                最新收录
              </h3>
              <div className="space-y-5">
                {latest.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="compact" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}